exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remind-tips[data-v-d850a506]{height:10.66667vw;background-color:#fff2e8;padding-left:4.8vw\n}\n.remind-tips p[data-v-d850a506]{font-size:3.73333vw;color:#ff904f\n}\n.remind-tips .info-icon[data-v-d850a506]{font-size:4.8vw;margin-right:2.13333vw;color:#ff904f\n}\n", ""]);

// exports
